import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { IntegrationRequiredModal } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { AssetAccessGrantWithParent } from 'types'
import { useModals } from 'almanac-ui/Modal'
import { SocialChannelType, platformIcons, platformKeyByChannel, platformNameFromChannel } from './Default'
import { ShareSheetItem } from 'common/ShareSheetV2/ShareSheetItem/ShareSheetItem'
import { Button } from 'blaze-ui/Button'
import { PostPreviewModal } from 'components/PostPreviewModal/PostPreviewModal'
import { PostableChannelType } from 'components/PostPreviewModal/Types'
import { useCurrentArticleMeta } from 'hooks/useCurrentArticleMeta'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useEffect } from 'react'
import { DesignChannel } from 'components/NewFileModal/Types'

type CardProps = {
  asset: AssetAccessGrantWithParent
  onClick: () => void
  label?: string
}

const Card = ({ asset, onClick, label }: CardProps) => {
  const platformName = platformNameFromChannel[asset.channel as SocialChannelType]
  const suffix = (asset.channel as SocialChannelType) === DesignChannel.InstagramStory ? 'story' : 'post'

  return (
    <ShareSheetItem
      title={`${platformName} ${suffix}`}
      description="Publish or schedule your post"
      onClick={onClick}
      fullWidth
      action={
        <Button size="lg" onPress={onClick}>
          {label}
        </Button>
      }
      icon={platformIcons[platformKeyByChannel[asset.channel as SocialChannelType]]}
    />
  )
}

export const PostToSocialItem = observer(({ asset }: { asset: AssetAccessGrantWithParent }) => {
  const integrations = useExternalIntegrations()
  const { designStore, files } = useRootStore()
  const design = designStore?.file
  const { openModal } = useModals()
  const article = useCurrentArticleMeta()
  const scheduledPostId =
    design?.scheduled_post_id || article?.scheduled_post?.id || files.get(asset.id)?.scheduled_post_id
  const integration = integrations.data?.external_integrations.find(
    (integration) => integration.provider === platformKeyByChannel[asset.channel as SocialChannelType],
  )

  useEffect(() => {
    files.fetch(asset.id)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!integration) {
    return (
      <Card
        asset={asset}
        label="Connect Account"
        onClick={() => {
          openModal(
            IntegrationRequiredModal,
            {
              integration: platformKeyByChannel[asset.channel as SocialChannelType] as ExternalIntegrationEnum,
            },
            { newStack: true },
          )
        }}
      />
    )
  }

  return (
    <Card
      label="Post or Schedule"
      asset={asset}
      onClick={() => {
        if (!scheduledPostId) return

        openModal(PostPreviewModal, {
          fileId: asset.id,
          scheduledPostId,
          channel: asset.channel as PostableChannelType,
          showSuccessToast: false,
          pollPreviewContentStream: false,
          target: asset.type === 'design' ? 'design' : 'text',
        })
      }}
    />
  )
})
